import * as stylex from '@stylexjs/stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
export const styles = {
  group: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1fwedmp",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  start: {
    kjj79g: "x1nhvcw1",
    $$css: true
  },
  center: {
    kjj79g: "xl56j7k",
    $$css: true
  },
  end: {
    kjj79g: "x13a6bvl",
    $$css: true
  },
  spread: {
    kjj79g: "x1qughib",
    kzqmXN: "xh8yej3",
    $$css: true
  },
  nowrap: {
    kwnvtZ: "xozqiw3",
    $$css: true
  }
};